import { inject, Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, take } from 'rxjs';
import { SlsPremiumTablesService } from '../../serverless/sls-premium-tables.service';
import { ClientBrandStats } from '../../serverless/sls-premium-tables.service';
import { FilterDashboard } from '@app/modules/dashboard/dashboard-components/services/filter.service';
import { UtilService } from '../../util.service';
import { UsersBrandsService } from '@app/core/api/services';
import { UsersBrands } from '@app/core/services/api/API.service';
import { BrandfactoryServerlessService } from '../../serverless/brandfactory-serverless.service';

@Injectable({
    providedIn: 'root'
})
export class BrandsService implements OnDestroy {
    private _brandfactoryServerlessService = inject(
        BrandfactoryServerlessService
    );
    private _brands$ = new BehaviorSubject<UsersBrands[]>([]);
    private _loading$ = new BehaviorSubject<boolean>(true);
    private brands: UsersBrands[] = [];

    private _isLoading = false;

    constructor(private _utilService: UtilService) {}

    ngOnDestroy(): void {
        this._brands$.complete();
        this._loading$.complete();
    }

    get brands$() {
        return this._brands$.asObservable();
    }

    get loading$() {
        return this._loading$.asObservable();
    }

    async listBrands() {
        if (this._isLoading) {
            return;
        }

        const existingBrands = this._brands$.getValue();
        if (existingBrands && existingBrands.length > 0) {
            return;
        }

        this._isLoading = true;
        try {
            this._loading$.next(true);
            this.brands =
                (await this._brandfactoryServerlessService.listBrands()) || [];
            this.brands = this._utilService.sortJSON(
                this.brands,
                'name',
                'asc'
            );
        } catch (error) {
            this.brands = [];
        } finally {
            this._brands$.next(this.brands);
            this._loading$.next(false);
            this._isLoading = false;
        }
    }

    async findBrandById(id: string): Promise<UsersBrands | undefined> {
        try {
            const brands = await this.brands$.pipe(take(1)).toPromise();
            return brands.find(brand => brand.id === id);
        } catch (error) {
            console.error('❌ Error al buscar la marca:', error);
            return undefined;
        }
    }
}
